<template>
  <div id="app">
    <component :is="layout">
      <transition name="slide-fade">
        <router-view />
      </transition>
      <div v-show="openOverlay" @click="vCloseSidebar" class="overlay"></div>
    </component>
  </div>
</template>

<script>
let defaultLayout = "blank";

import { Bus } from '@/common/Bus';

import Network from '@/common/lib/Network';

export default {
  data() {
    return {
      openOverlay: false
    };
  },
  beforeCreate() {
    
    if(this.$store.getters['application/get_application_user']['lang'] === undefined) {

      let params = {
        lang: navigator.language
      };

      if (Object.entries(this.$store.getters['application/get_application_translation']).length === 0) {
          
        Network.execute('GET', 'get_lang_file', params)
        .then(res => {
          this.$store.dispatch("application/SATABAPP_STORE", {
            key: "satabapp-translation",
            val: res.data
          });
        });
      }
    }
  },
  created() {

    this.$store.dispatch('application/SATABAPP_LOAD')
  
    Bus.$on('overlay', (state) => {

      this.openOverlay = state

      var body = document.body;

      if (state === true) {
        body.classList.add("no-scroll");
      } else {
        body.classList.remove("no-scroll");
        Bus.$emit('sidemenuclose');
      }
    });
  },
  computed: {
    layout() {
      return this.$route.meta.layout || defaultLayout;
    },
  },
  watch: {
    token(val) {
      console.error(val);
    }
  },
  methods: {
    vCloseSidebar() {
      Bus.$emit('openSidebar');
      Bus.$emit('overlay');
    }
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(15, 20, 35, 0.9);
  height: 100vh;
  z-index: 1000;
}
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(200px);
  opacity: 0;
}
</style>
